import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { PRODUCT, formatPrice, getColor, productUrl } from "../../data/catalog";
import { useCart } from "../../context/CartContext";
import { Swatches } from "./Swatches";

export const QuickView = ({ colorId, onClose }) => {
  const [cid, setCid] = useState(colorId);
  const { add, setOpen } = useCart();
  useEffect(() => { if (colorId) setCid(colorId); }, [colorId]);
  const c = getColor(cid);

  const addToBag = () => {
    add(c.id, 1);
    toast.success(`${PRODUCT.name} — ${c.name} added to your bag`);
    onClose();
    setOpen(true);
  };

  return (
    <Dialog open={!!colorId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-lenis-prevent className="max-h-[92vh] max-w-4xl gap-0 overflow-y-auto rounded-none border-line bg-ivory p-0 md:grid md:grid-cols-2" data-testid="quick-view-modal">
        <div className="relative aspect-square bg-white">
          <AnimatePresence initial={false}>
            <motion.img key={c.id} src={c.image} alt={c.name} initial={{ opacity: 0, scale: 1.03 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }} className="absolute inset-0 h-full w-full object-contain p-8" />
          </AnimatePresence>
        </div>
        <div className="flex flex-col gap-5 p-7 md:p-10">
          <p className="label-mono">Belt Bag · Crossbody</p>
          <DialogTitle className="font-display text-3xl font-normal leading-tight text-ink">{PRODUCT.name}</DialogTitle>
          <p className="text-lg text-ink" data-testid="quick-view-price">{formatPrice(PRODUCT.price)}</p>
          <div>
            <p className="mb-3 text-sm text-graphite">Color: <span className="text-ink" data-testid="quick-view-color-name">{c.name}</span></p>
            <Swatches value={c.id} onChange={setCid} prefix="quick-view" />
          </div>
          <p className="text-sm leading-relaxed text-graphite">{PRODUCT.description}</p>
          <button className="btn-dark mt-auto" onClick={addToBag} data-testid="quick-view-add-to-cart">Add to bag</button>
          <Link to={productUrl(c.id)} onClick={onClose} className="link-line self-start text-xs uppercase tracking-[0.2em]" data-testid="quick-view-full-details">View full details</Link>
        </div>
      </DialogContent>
    </Dialog>
  );
};
